import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface IPassengerDetailTicketAttributes extends IModelAttributes {
	passengerDetailId: string;
	ticketId: string;

	passengerDetail: Models.PassengerDetailEntity | Models.IPassengerDetailEntityAttributes;
	ticket: Models.TicketEntity | Models.ITicketEntityAttributes;
}

@entity('PassengerDetailTicket')
export default class PassengerDetailTicket extends Model implements IPassengerDetailTicketAttributes {
	@observable
	@attribute()
	public passengerDetailId: string;

	@observable
	@attribute()
	public ticketId: string;

	@observable
	@attribute({ isReference: true })
	public passengerDetail: Models.PassengerDetailEntity;

	@observable
	@attribute({ isReference: true })
	public ticket: Models.TicketEntity;

	constructor(attributes?: Partial<IPassengerDetailTicketAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.passengerDetailId) {
				this.passengerDetailId = attributes.passengerDetailId;
			}
			if (attributes.ticketId) {
				this.ticketId = attributes.ticketId;
			}

			if (attributes.passengerDetail) {
				if (attributes.passengerDetail instanceof Models.PassengerDetailEntity) {
					this.passengerDetail = attributes.passengerDetail;
					this.passengerDetailId = attributes.passengerDetail.id;
				} else {
					this.passengerDetail = new Models.PassengerDetailEntity(attributes.passengerDetail);
					this.passengerDetailId = this.passengerDetail.id;
				}
			} else if (attributes.passengerDetailId !== undefined) {
				this.passengerDetailId = attributes.passengerDetailId;
			}

			if (attributes.ticket) {
				if (attributes.ticket instanceof Models.TicketEntity) {
					this.ticket = attributes.ticket;
					this.ticketId = attributes.ticket.id;
				} else {
					this.ticket = new Models.TicketEntity(attributes.ticket);
					this.ticketId = this.ticket.id;
				}
			} else if (attributes.ticketId !== undefined) {
				this.ticketId = attributes.ticketId;
			}
		}
	}
}
